<template>

    <div class="dash-content-outer col">

        <div class="head">
            <h5 class="txt-grt">Contents</h5>
            <div class="actns">
                <div class="sorter" ref="innerSorter">
                    <div class="dft" @click.prevent="toggleSorter">
                        <div>
                            <span class="placeholder">Sort by : </span>
                            <span class="crt txt-main">{{ currentSorting }}</span>
                        </div>
                        <span class="arw" :class="{ spn : openedSorter }">
                            <svg width="13" height="8" viewBox="0 0 13 8" fill="none">
                                <path d="M12 1L6.5 6L1 0.999999" stroke="#FAC143" stroke-width="2.5"/>
                            </svg>
                        </span>
                    </div>
                    <ul class="extended col" :class="{ opnd : openedSorter }">
                        <li @click.prevent="sortBy('Last added')" :class="{ active : currentSorting == 'Last added' }">Last added</li>
                        <li @click.prevent="sortBy('Name')" :class="{ active : currentSorting == 'Name' }">Name</li>
                        <!-- <li @click.prevent="sortBy('By tags')" :class="{ active : currentSorting == 'By tags' }">By tags</li> -->
                    </ul>
                </div>
                <div class="btn main txt-blk" @click.prevent="openContentOverlay" ref="addContentCta">
                    <span class="hvr"></span>
                    <span class="ico">
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z" fill="black"/>
                        </svg>
                    </span>
                    <span class="txt">Add new content</span>
                </div>
            </div>
        </div>

        <div class="inner-content">
            
            <!-- ALEX: Si t'aime pas tu vire !!! Hésite pas ! -->
            <transition-group name="list" tag="div" class="all-contents">

                <ContentCard v-for="asset in sortedAssets"
                    :posterSrc="asset.poster"
                    :title="asset.name"
                    :genreTags="asset.tags"
                    :moneyTag="Global.plans[asset.planIndex].name"
                    :key="asset.name"
                    :index="asset.index"
                >
                </ContentCard>
            
                <div class="card ft-bld more" @click.prevent="openContentOverlay" key="more">
                    <div class="bg top"></div>
                    <div class="bg bot"></div>
                    <div class="ctnt col">
                        <span class="ico">
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z" fill="#FFBB36"/>
                            </svg>
                        </span>
                        <span class="txt txt-main">Add new content</span>
                    </div>
                </div>

            </transition-group>
                
        </div>

    </div>

</template>

<style scoped>
    .list-move {
        transition: transform 400ms ease-out;
    }    
</style>

<script>

    import Global from '../../lib/GlobalState'
    import ContentCard from '../../components/ContentCard'
    import { EventBus } from '../../event-bus.js'

    export default {

        name: 'Contents',

        components: {
            ContentCard
        },

        data() {
            return {
                Global,
                openedSorter: false,
                currentSorting: 'Name'
            }
        },

        computed: {

            sortedAssets() {

                const assets = Object.assign([], this.Global.assets).map((asset, index) => {
                    asset.index = index
                    return asset
                })

                if(this.currentSorting == "Last added") {
                    return assets.reverse()
                }

                return assets.sort((a,b) => {
                    let x = a.name.toLowerCase();
                    let y = b.name.toLowerCase();

                    if(x>y){return 1;} 
                    if(x<y){return -1;}
                    return 0;
                })
            }
        },

        created() {
            EventBus.$on('globalResize', () => { this.localResize() });
        },

        mounted() {
            document.body.addEventListener('click', this.bodyClick)
            setTimeout(() => { this.localResize() }, 1400)
            setTimeout(() => { this.toggleHelper() }, 1500)
        },

        methods: {

            localResize(){
                if(this.$route.path !== '/dashboard/contents' || this.Global.ContentsHelperOverlayState == 2) return
                this.ctaGetPos()
            },

            ctaGetPos() {
                const el = this.$refs.addContentCta
                const top = el.getBoundingClientRect().top
                const left = el.getBoundingClientRect().left
                this.Global.ContentsHelperOverlayPos.x = left
                this.Global.ContentsHelperOverlayPos.y = top
            },

            toggleHelper() {
                if(this.$route.path !== '/dashboard/contents' || this.Global.ContentsHelperOverlayState > 0) return
                this.Global.tempHelperClosingOverlay = false
                this.Global.activeHelperOverlay = true
                this.Global.ContentsHelperOverlayState = 1
            },

            toggleSorter(){
                this.openedSorter = !this.openedSorter
            },

            sortBy(type){
                this.currentSorting = type
                this.openedSorter = false
            },

            bodyClick(event) {
                if (!this.openedSorter) return
                let el = '.' + this.$refs.innerSorter.classList[0] + ' *'
                if (!event.target.matches(el))
                    this.openedSorter = false
            },

            openContentOverlay() {
                this.$parent.openContentOverlay()
            },
        },

        beforeDestroy() {
            document.body.removeEventListener('click', this.bodyClick)
            // EventBus.$off('globalResize');
        }
    }

</script>